module.exports = __webpack_public_path__ + "static/media/teacherRate.b2cf87ed.jpeg";